import { makeStyles } from "@material-ui/core/styles";

export const useIntegrationLogoStyles = makeStyles((theme) => {
  return {
    container: {
      textAlign: "center",
    },
    awsTxt: {
      fill: theme.svgs.aws.txt.color,
    },
    awsSmile: {
      fill: theme.svgs.aws.smile.color,
    },
    duoGreen1: {
      fill: theme.svgs.duo.green1.color,
    },
    duoGreen2: {
      fill: theme.svgs.duo.green2.color,
    },
    m365Txt: {
      fill: theme.svgs.m365.txt.color,
    },
    m365sq1: {
      fill: theme.svgs.m365.sq1.color,
    },
    m365sq2: {
      fill: theme.svgs.m365.sq2.color,
    },
    m365sq3: {
      fill: theme.svgs.m365.sq3.color,
    },
    m365sq4: {
      fill: theme.svgs.m365.sq4.color,
    },
    sentinelTxt: {
      fill: theme.svgs.sentinel.txt.color,
    },
    sentinelLogo: {
      fill: theme.svgs.sentinel.logo.color,
    },
    mimecastText: {
      fill: theme.svgs.mimecast.txt.color,
    },
  };
});
